import {compose} from 'recompose';

import RatingView from './RatingView';

export default compose()(RatingView);
